import * as React from 'react';
import { Edit3, Send, PlusCircle, FileText, Video, Upload } from 'lucide-react';
import { useLocation, useNavigate } from 'react-router-dom';
import { EDIT_WEBSITE_CONTENT_BASE_PATH } from '../routes/editWebsiteContentPaths';
import { UPLOAD_VIDEOS_BASE_PATH } from '../routes/uploadVideoPaths';
import { REELS_BASE_PATH } from '../routes/reelPaths';
import { CREATE_POST_BASE_PATH } from '../routes/createPostPaths';
import { DMButton, DMDiv, DMText } from './Primitives';

export const QuickActions = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const actions = [
    {
      icon: <Edit3 className="w-[2.4vh] h-[2.4vh] shrink-0 text-amber-600" />,
      label: 'Edit Website Content',
      path: EDIT_WEBSITE_CONTENT_BASE_PATH,
      bg: 'bg-gradient-to-r from-amber-100 to-amber-200',
      border: 'border-amber-400',
    },
    {
      icon: (
        <FileText className="w-[2.4vh] h-[2.4vh] shrink-0 text-indigo-600" />
      ),
      label: 'Blog Posts',
      path: '/digital-marketing/blog',
      bg: 'bg-gradient-to-r from-indigo-100 to-purple-200',
      border: 'border-indigo-400',
    },
    {
      icon: <Send className="w-[2.4vh] h-[2.4vh] shrink-0 text-emerald-600" />,
      label: 'Send Wishes',
      path: '/digital-marketing/send-wishes',
      bg: 'bg-gradient-to-r from-green-100 to-emerald-200',
      border: 'border-emerald-400',
    },
    {
      icon: (
        <PlusCircle className="w-[2.4vh] h-[2.4vh] shrink-0 text-orange-600" />
      ),
      label: 'Posted Content',
      path: CREATE_POST_BASE_PATH,
      bg: 'bg-gradient-to-r from-orange-100 to-rose-200',
      border: 'border-orange-400',
    },
    {
      icon: <Video className="w-[2.4vh] h-[2.4vh] shrink-0 text-teal-600" />,
      label: 'Reels',
      path: REELS_BASE_PATH,
      bg: 'bg-gradient-to-r from-teal-100 to-emerald-100',
      border: 'border-teal-400',
    },
    {
      icon: (
        <Upload className="w-[2.4vh] h-[2.4vh] shrink-0 text-fuchsia-600" />
      ),
      label: 'Videos',
      path: UPLOAD_VIDEOS_BASE_PATH,
      bg: 'bg-gradient-to-r from-fuchsia-100 to-pink-200',
      border: 'border-fuchsia-400',
    },
  ];

  const handleNavigate = (path?: string) => {
    if (!path || location.pathname === path) {
      return;
    }

    navigate(path);
  };

  return (
    <DMDiv className="mb-[1.5vh]">
      <DMText
        as="h2"
        className="text-[1.6vh] font-bold text-gray-800 leading-tight mb-[1vh] shrink-0 uppercase"
      >
        Quick Actions
      </DMText>
      <DMDiv className="flex w-full justify-between gap-[1vh] px-[0.35vh]">
        {actions.map((action, i) => {
          const isActive = Boolean(
            action.path && location.pathname.startsWith(action.path)
          );
          const isDisabled = !action.path;

          return (
            <DMButton
              key={i}
              type="button"
              onClick={() => handleNavigate(action.path)}
              disabled={isDisabled}
              className={`relative flex min-w-0 flex-1 items-center justify-center gap-[0.8vh] rounded-full border px-[1vh] py-[1.2vh] text-[1.6vh] font-medium text-gray-800 shadow-[inset_0_2px_4px_rgba(255,255,255,0.7),0_2px_4px_rgba(0,0,0,0.18)] backdrop-blur-xl transition-[box-shadow,filter,transform,border-color] duration-300 ease-out hover:-translate-y-[0.15vh] hover:brightness-[1.03] hover:shadow-[inset_0_2px_4px_rgba(255,255,255,0.9),0_4px_10px_rgba(0,0,0,0.24)] disabled:cursor-not-allowed disabled:opacity-55 disabled:hover:translate-y-0 disabled:hover:brightness-100 xl:text-[1.8vh] ${
                action.bg
              } ${
                isActive
                  ? 'border-primary-main ring-2 ring-primary-main/20'
                  : action.border
              }`}
              aria-current={isActive ? 'page' : undefined}
            >
              {isActive && (
                <DMText
                  as="span"
                  className="absolute left-[1.1vh] h-[1vh] w-[1vh] rounded-full bg-primary-main"
                />
              )}
              {action.icon}
              <DMText
                as="span"
                className="truncate whitespace-nowrap leading-tight"
              >
                {action.label}
              </DMText>
            </DMButton>
          );
        })}
      </DMDiv>
    </DMDiv>
  );
};

